var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.98438,31.03564a2.89282,2.89282,0,1,0-2.89258-2.89257A2.89606,2.89606,0,0,0,39.98438,31.03564Zm0-4.28564a1.39282,1.39282,0,1,1-1.39258,1.39307A1.39484,1.39484,0,0,1,39.98438,26.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.23438,
    y: 36.71436,
    width: 1.5,
    height: 19.28564
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,70.75A30.75,30.75,0,1,0,9.25,40,30.78457,30.78457,0,0,0,40,70.75Zm0-60A29.25,29.25,0,1,1,10.75,40,29.28292,29.28292,0,0,1,40,10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.8e15746435482da73655422f60a74444.svg";
export { ForwardRef as ReactComponent };